import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import React from 'react'
import { connect } from 'react-redux'
import Zestawienie from '../../components/Zestawienie/Zestawienie'
import ZestawienieHeader from '../../components/Zestawienie/ZestawienieHeader'
import ZestawienieName from '../../components/Zestawienie/ZestawienieName'
import {
  formulyRachunekPrzeplywowBezposredni,
  formulyRachunekPrzeplywowPosredni,
  formulySkonsolidowanyRachunekPrzeplywowBezposredni,
  formulySkonsolidowanyRachunekPrzeplywowPosredni,
} from '../../lib/formulas'
import zaokragl from '../../lib/mathUtils'
import { czyKwotyWTysiacach, dajStrukture } from '../../lib/structureChecker'
import * as actions from '../../store/actions'
import RachunekPrzeplywowStyle from '../../styles/RachunekPrzeplywowStyle'
import ImportCSVInfo from '../../components/Zestawienie/ImportCSVInfo'
import InfoPanel from '../../components/InfoPanel'

export class RachunekPrzeplywow extends React.Component {
  isValueInThirdColumn = () => {
    return (
      this.props.section.Dane.PozycjePosredni.some(i => i.KwotaB1 !== 0) ||
      this.props.section.Dane.PozycjeBezposredni.some(i => i.KwotaB1 !== 0)
    )
  }

  state = { isThirdColumn: this.isValueInThirdColumn(), czyszczenie: false }

  setIsThirdColumn = v => {
    this.setState({ isThirdColumn: v })
  }

  getValue = (index, name) => {
    if (this.props.section.Dane.WybranaMetoda === 'Pośrednia')
      return this.props.section.Dane.PozycjePosredni[index][name]
    else if (this.props.section.Dane.WybranaMetoda === 'Bezpośrednia')
      return this.props.section.Dane.PozycjeBezposredni[index][name]
  }

  sumValues = (value, changedIndex, name, parts) => {
    let partsSum = 0
    parts.forEach(x => {
      if (x < 0) {
        let i = Math.abs(x)
        partsSum = zaokragl(
          partsSum -
            (i === changedIndex ? parseFloat(value) : this.getValue(i, name)),
        )
      } else
        partsSum = zaokragl(
          partsSum +
            (x === changedIndex ? parseFloat(value) : this.getValue(x, name)),
        )
    })
    return partsSum
  }

  aktualizujSumy = (value, index, name) => {
    if (this.state.czyszczenie) return
    if (!value) value = 0
    let arrayName, formuly
    if (this.props.section.Dane.WybranaMetoda === 'Pośrednia') {
      arrayName = 'PozycjePosredni'
      formuly =
        this.props.struktura === 'SkonsolidowanaInna'
          ? formulySkonsolidowanyRachunekPrzeplywowPosredni
          : formulyRachunekPrzeplywowPosredni
    } else if (this.props.section.Dane.WybranaMetoda === 'Bezpośrednia') {
      arrayName = 'PozycjeBezposredni'
      formuly =
        this.props.struktura === 'SkonsolidowanaInna'
          ? formulySkonsolidowanyRachunekPrzeplywowBezposredni
          : formulyRachunekPrzeplywowBezposredni
    }

    this.props.onSetSectionDataCustomArray(value, index, arrayName, name)

    formuly.forEach(x => {
      let suma = this.sumValues(value, index, name, x.polaSkladowe)
      this.props.onSetSectionDataCustomArray(suma, x.poleSumy, arrayName, name)
    })
  }

  handleCheckbox = () => {
    if (!this.props.section.Dane.WybranaMetoda) this.setMetoda('Pośrednia')
    else this.setMetoda(null)
  }

  setMetoda = metoda => {
    this.props.onSetSectionData('WybranaMetoda', metoda, 0)
  }

  czyszczenie = async () => {
    this.setState({ czyszczenie: true })
    const metoda = this.props.section.Dane.WybranaMetoda
    if (metoda === 'Pośrednia') this.props.onClearTable('PozycjePosredni')
    else if (metoda === 'Bezpośrednia')
      this.props.onClearTable('PozycjeBezposredni')
    await this.setState({ czyszczenie: false })
  }

  render() {
    const { section, czyKwotyWTysiacach, onImportCSV, id } = this.props
    return (
      <>
        <InfoPanel rolledContent={ImportCSVInfo} />
        <RachunekPrzeplywowStyle
          className={section.Dane.WybranaMetoda !== null ? '' : 'hide-on-print'}
        >
          <ZestawienieName
            name="RACHUNEK PRZEPŁYWÓW PIENIĘŻNYCH"
            onImport={file => onImportCSV(id, section, file)}
            onClear={this.czyszczenie}
            hideButtons={!section.Dane.WybranaMetoda}
          />
          <FormControlLabel
            className="checkbox-label"
            control={
              <Checkbox
                color="primary"
                checked={section.Dane.WybranaMetoda !== null}
                onChange={this.handleCheckbox}
              />
            }
            label="Dołącz rachunek przepływów pieniężnych"
          />
          {section.Dane.WybranaMetoda !== null && (
            <>
              <RadioGroup
                row
                className="radioGroup"
                value={section.Dane.WybranaMetoda}
                onChange={e => this.setMetoda(e.target.value)}
              >
                <FormControlLabel
                  value="Pośrednia"
                  control={<Radio color="primary" />}
                  label="Metoda pośrednia"
                />
                <FormControlLabel
                  value="Bezpośrednia"
                  control={<Radio color="primary" />}
                  label="Metoda bezpośrednia"
                />
              </RadioGroup>
            </>
          )}
          <div className="container">
            {section.Dane.WybranaMetoda === 'Pośrednia' && (
              <>
                <ZestawienieHeader
                  isThirdColumn={this.state.isThirdColumn}
                  onCheck={e => this.setIsThirdColumn(e.target.checked)}
                />
                <div className="list">
                  <Zestawienie
                    dane={section.Dane.PozycjePosredni}
                    onSetSectionDataArray={this.aktualizujSumy}
                    czyKwotyWTysiacach={czyKwotyWTysiacach}
                    isThirdColumn={this.state.isThirdColumn}
                    czyPolaBezKwot={this.props.czyPolaBezKwot}
                  />
                </div>
              </>
            )}
            {section.Dane.WybranaMetoda === 'Bezpośrednia' && (
              <>
                <ZestawienieHeader
                  isThirdColumn={this.state.isThirdColumn}
                  onCheck={e => this.setIsThirdColumn(e.target.checked)}
                />
                <div className="list">
                  <Zestawienie
                    dane={section.Dane.PozycjeBezposredni}
                    onSetSectionDataArray={this.aktualizujSumy}
                    czyKwotyWTysiacach={czyKwotyWTysiacach}
                    isThirdColumn={this.state.isThirdColumn}
                    czyPolaBezKwot={this.props.czyPolaBezKwot}
                  />
                </div>
              </>
            )}
          </div>
        </RachunekPrzeplywowStyle>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    czyKwotyWTysiacach: czyKwotyWTysiacach(state.sprawozdanie.header),
    struktura: dajStrukture(state.sprawozdanie.header),
    id: state.sprawozdanie.header.Id,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSetSectionData: (name, value, index) => {
      dispatch(actions.setSectionData(name, value, index))
    },
    onSetSectionDataCustomArray: (value, index, arrayName, name) => {
      dispatch(actions.setSectionDataCustomArray(value, index, arrayName, name))
    },
    onImportCSV: (id, section, file) => {
      dispatch(actions.importCSV(id, section, file))
    },
    onClearTable: array => dispatch(actions.clearTable(array)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RachunekPrzeplywow)
